import { AuthAction } from "../auth/actionTypes";

export enum TypeKeys {
    LOAD_PROFILE_LIST = "LOAD_PROFILE_LIST",
    RECEIVE_PROFILE_LIST = "RECEIVE_PROFILE_LIST",
    USER_SELECTED_PROFILE_ID = "USER_SELECTED_PROFILE_ID",
    RECEIVE_PROFILE = "RECEIVE_PROFILE",

}

export interface LoadProfileList {
    type: TypeKeys.LOAD_PROFILE_LIST,
}

export interface ReceiveProfileList {
    type: TypeKeys.RECEIVE_PROFILE_LIST,
    profileList: any[],
    searchError: boolean,
}

export interface SelectProfileId {
    type: TypeKeys.USER_SELECTED_PROFILE_ID,
    profileId: string
}

export type AppAction =
LoadProfileList
| ReceiveProfileList
| SelectProfileId
| AuthAction;
